<template>
  <v-container>
    <!-- Diálogo modal Persistente para seleccionar la Caseta -->
    <v-dialog v-model="dialogInitial" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{$t('selecciona_caseta')}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form
                    @submit.prevent="setGuardHouse()">
              <v-col cols="12" sm="12">
                <v-autocomplete
                        v-model="guardHouse"
                        name="guardHouse"
                        :items="guardHouses"
                        item-text="name"
                        return-object
                        :label="$t('guardhouses')"
                        autocomplete="off"
                ></v-autocomplete>
              </v-col>
              <v-btn
                      color="primary"
                      type="submit"
              >{{ $t('aceptar') }}
              </v-btn>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <h1>{{ $t('Bienvenido') }}: {{getProfile.first_name}} {{getProfile.last_name}}</h1>
    <v-layout align-center justify-center>
      <v-flex>
        <v-card class="elevation-5">
          <v-img
                  v-if="(getProfile.role === 2 || getProfile.role === 3 || getProfile.role === 4 || getProfile.role === 6) && getProfile.wallpaper !== null"
                  :src="getProfile.wallpaper"
          ></v-img>
          <v-img
                  v-else
                  :src="require('../assets/home03.jpg')"
          ></v-img>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
import store from '@/store'
import {HTTP} from '@/main.js'

export default {
  name: 'home',
  data () {
    return {
      dialogInitial: false,
      guardHouse: null,
      guardHouses: [],
      role: 0,
      devices: [],
      cams: [],
      qrs: [],
      listaEstudiantesLocal: []
    }
  },
  computed: {
    ...mapGetters(['getProfile'])
  },
  beforeMount() {
    this.$options.sockets = {
      onmessage: data => this.messageReceived(data)
    }
  },
  created () {
    this.getExtraData()
  },
  methods: {
    messageReceived(data) {
      // console.log(JSON.parse(data.data))
      console.log('Parseados ', JSON.parse(data.data).message)
      let type = JSON.parse(JSON.parse(data.data).message)
      switch (this.getProfile.role) {
        case 2: // Vigilante
          if (type.classification) {
            let qr_code = type.data
            switch (type.classification) {
              case 'qr':
                console.log('QR Code')
                if (qr_code !== '') {
                  HTTP.get('student/access_code/' + qr_code + '/' + localStorage.getItem('idGuardHouse'), {
                    headers: {
                      'Content-Type': 'application/json',
                      'authorization': 'Token ' + localStorage.getItem('user-token')
                    }
                  })
                      .then(response => {
                        // console.log(this.info_invitation.students[0].avatar)
                        var item = response.data
                        var studentfiltered = this.deleteStudentNoAttendance(item.available_students)
                        item.available_students = studentfiltered
                        this.sendNotificationToTeachers(item, type.guardhouse_name)
                        var fullItem = Object.assign(item, {"qrCode": qr_code})
                        console.log(fullItem)
                        if(item.available_students.length > 0) {
                          this.addListItem(fullItem)
                          localStorage.setItem('listaEstudiantes',  JSON.stringify(this.listaEstudiantesLocal))
                          this.$socket.send(JSON.stringify( {
                            "message": JSON.stringify(this.listaEstudiantesLocal)
                          }))
                        }
                      })
                      .catch(error => {
                        console.log(error)
                      })
                }
                break
            }
          } else {
            localStorage.setItem('listaEstudiantes', JSON.parse(data.data).message)
            this.$store.commit('setStudentsList', JSON.parse(data.data).message)
          }
        break;
        case 4: // Administrador
          if (type.classification) {
            switch (type.classification) {
              case 'rfid':
                this.$store.commit('setRFID', type.data)
                break;
            }
          }
        break;
      }
      if(this.getProfile.role === 2) { //Si es Vigilante
        if (type.classification) { // Si la informacion se escaneo desde totem
        let qr_code = type.data
        switch (type.classification) {
          case 'qr':
            console.log('QR Code')
            if (qr_code !== '') {
              HTTP.get('student/access_code/' + qr_code + '/' + localStorage.getItem('idGuardHouse'), {
                headers: {
                  'Content-Type': 'application/json',
                  'authorization': 'Token ' + localStorage.getItem('user-token')
                }
              })
              .then(response => {
                // console.log(this.info_invitation.students[0].avatar)
                var item = response.data
                var studentfiltered = this.deleteStudentNoAttendance(item.available_students)
                item.available_students = studentfiltered
                var fullItem = Object.assign(item, {"qrCode": qr_code})
                console.log(fullItem)
                if(item.available_students.length > 0) {
                  this.addListItem(fullItem)
                  this.sendNotificationToTeachers(item, type.guardhouse_name)
                  // localStorage.setItem('listaEstudiantes',  JSON.stringify(this.listaEstudiantesLocal))
                  // this.$socket.send(JSON.stringify( {
                  //   "message": JSON.stringify(this.listaEstudiantesLocal)
                  // }))
                }
              })
              .catch(error => {
                console.log(error)
              })
            }
          break
        }
       } else { // Si la informacion es entre sesiones de vigilantes
        // Obtener datos de los Tutores/Invitados y Estudiantes
        // localStorage.setItem('listaEstudiantes', JSON.parse(data.data).message)
        // this.$store.commit('setStudentsList', JSON.parse(data.data).message)
        this.getQrCodes()
        }
      }
    },
    getQrCodes () {
      HTTP.get('checkout_list/' + localStorage.getItem('idGuardHouse') + '/',
        {
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + localStorage.getItem('user-token')
          }
        })
        .then(response => {
          this.getCheckOutList(response.data)
          console.log(response)
        })
        .catch(error => {
          console.log(error)
        })
    },
    getCheckOutList (list) {
      let qr_codes_aux = []

      for(let i = 0; i< list.length; i++) {
        qr_codes_aux.push({
          'qr_code': list[i].qr_code
        })
      }
      HTTP.post('students/access_code/filter/' + localStorage.getItem('idGuardHouse'), {
          qr_codes: qr_codes_aux
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + store.getters.getToken
          }
        })
      .then(response => {
        localStorage.setItem('listaEstudiantes', JSON.stringify(response.data))
        this.$store.commit('setStudentsList', JSON.stringify(response.data))
        console.log(response)
      })
      .catch(error => {
        console.log(error)
      })
    },
    addListItem(item) {
      let band = false

      for(let i = 0 ; !band && i < this.listaEstudiantesLocal.length; i++) {
        console.log(this.listaEstudiantesLocal[i].qrCode, '===', item.qrCode)
        if(this.listaEstudiantesLocal[i].qrCode === item.qrCode){
          band = true
        }
      }
      if (!band) {
        this.listaEstudiantesLocal.push(item)
        // Agregar registro a la Base de Datos
        this.addQRCodeToDB(item.qrCode)
        this.$socket.send(JSON.stringify( {
          "message":  JSON.stringify('addRecord')
        }))
      }
      console.log(this.listaEstudiantesLocal)
    },
    deleteStudentNoAttendance(item) {
      let res = []
      console.log(item)
      for (let i=0; i < item.length; i++) {
        if(item[i].status !== -1) {
          console.log(item[i].status)
          res.push(item[i])
        }
      }
      return res
    },
    addQRCodeToDB (aQRCode) {
      HTTP.post('checkout_list/',
        {
          idSchool: localStorage.getItem('idSchool'),
          idGuardhouse: localStorage.getItem('idGuardHouse'),
          qr_code: aQRCode
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + localStorage.getItem('user-token')
          }
        })
        .then(ok => {
          console.log(ok)
        })
        .catch(error => {
          console.log(error)
        })
    },
    sendNotificationToTeachers (data, name) {
      for(let i = 0; i < data.available_students.length; i++) {
        if (data.available_students[i].status !== -1) {
          HTTP.post('student/' + data.available_students[i].id + '/exit/notification/',
            {
                guardhouse_name: name
            },
            {
              headers: {
                'Content-Type': 'application/json',
                'Accept-Language': this.language,
                'authorization': 'Token ' + localStorage.getItem('user-token')
              }
          })
          .then(ok => {
            console.log(ok)
          })
          .catch(error => {
            console.log(error)
          })
        }
        setTimeout(this.clearTime, 100)
      }
    },
    clearTime () {
      console.log('Time...')
    },
    getExtraData () {
      HTTP.get('api/users/me/', {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        this.role = response.data.role
        if (this.role === 2) { // Si es Vigilante
          this.getGuardHouse()
          console.log(localStorage.getItem('idGuardHouse'))
          if (localStorage.getItem('idGuardHouse') === null) {
            this.dialogInitial = true
          }
        }
      })
      .catch(error => {
        console.log(error)
      })
    },
    getGuardHouse () {
      HTTP.get('guardhouse/', {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        this.guardHouses = response.data
      })
      .catch(error => {
        console.log(error)
      })
    },
    getGradeGuardHouse () {
      HTTP.get('gradeguardhouse', {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        console.log('GradeGuardHouse', response.data)
        localStorage.setItem('gradesGuardHouse',  JSON.stringify(response.data))
      })
      .catch(error => {
        console.log(error)
      })
    },
    getDevicesByGuardHouse () {
      HTTP.get('guardhouse/' + localStorage.getItem('idGuardHouse') + '/devices/', {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
        .then(response => {
          this.devices = response.data
          for (let i = 0; i < this.devices.length; i++) {
            if (this.devices[i].classification === 'qr') {
              this.qrs.push(this.devices[i])
            }
            // if (this.devices[i].classification === 'cam') {
            //   this.cams.push(this.devices[i])
            // }
          }
          localStorage.setItem('qr_devices', JSON.stringify(this.qrs))
          this.$store.commit('setQRDevices', JSON.parse(localStorage.getItem('qr_devices')))
          // localStorage.setItem('cam_devices', JSON.stringify(this.cams))
          // this.$store.commit('setCamDevices', JSON.parse(localStorage.getItem('cam_devices')))
          if (this.qrs.length > 0) {
            this.$store.commit('enableBandQr', true)
            localStorage.setItem('banderaQR', true)
          } else {
            this.$store.commit('enableBandQr', false)
            localStorage.setItem('banderaQR', false)
          }
          // if (this.cams.length > 0) {
          //   localStorage.setItem('banderaCam', true)
          //   this.$store.commit('enableBandCam', true)
          // } else {
          //   localStorage.setItem('banderaCam', false)
          //   this.$store.commit('enableBandCam', false)
          // }
          // if (this.devices.length > 0) {
            //Desconectar del Primer Socket
            // this.$disconnect()
            // Iniciar Sesión en Socket
          this.$connect('wss://escuela-service.intrare.app/ws/websocket/' + localStorage.getItem('idGuardHouse') + '/?token=' +  localStorage.getItem('user-token'))
          this.getGradeGuardHouse()
          // }
        })
        .catch(error => {
          console.log(error)
        })
    },
    setGuardHouse () {
      if (this.guardHouse !== null) {
        localStorage.setItem('idGuardHouse', this.guardHouse.id)
        localStorage.setItem('guardhouse_name', this.guardHouse.name)
        this.$store.commit('setGuardhouseName', this.guardHouse.name)
        // Obtenemos Dispositivos de la Caseta
        this.getDevicesByGuardHouse()
        this.dialogInitial = false
      }
    },
  }
}
</script>
